import React from "react";
const Phone: React.FC = () => (
  <svg
    width="56"
    height="56"
    viewBox="0 0 56 56"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12.25 8.75V43.75M12.25 51.625C12.25 52.3212 12.5266 52.9889 13.0188 53.4811C13.5111 53.9734 14.1788 54.25 14.875 54.25H41.125C41.8212 54.25 42.4889 53.9734 42.9812 53.4811C43.4734 52.9889 43.75 52.3212 43.75 51.625V43.75H12.25V51.625ZM43.75 4.375C43.75 3.67881 43.4734 3.01113 42.9812 2.51884C42.4889 2.02656 41.8212 1.75 41.125 1.75H14.875C14.1788 1.75 13.5111 2.02656 13.0188 2.51884C12.5266 3.01113 12.25 3.67881 12.25 4.375V8.75H43.75V4.375ZM43.75 43.75V8.75V43.75Z"
      stroke="#2E83FA"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M28 50.75C28.9665 50.75 29.75 49.9665 29.75 49C29.75 48.0335 28.9665 47.25 28 47.25C27.0335 47.25 26.25 48.0335 26.25 49C26.25 49.9665 27.0335 50.75 28 50.75Z"
      stroke="#2E83FA"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default Phone;
